var T = Object.defineProperty;
var o = Object.getOwnPropertySymbols;
var y = Object.prototype.hasOwnProperty, m = Object.prototype.propertyIsEnumerable;
var i = (e, t, s) => t in e ? T(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, r = (e, t) => {
  for (var s in t || (t = {}))
    y.call(t, s) && i(e, s, t[s]);
  if (o)
    for (var s of o(t))
      m.call(t, s) && i(e, s, t[s]);
  return e;
};
var c = (e, t) => {
  var s = {};
  for (var a in e)
    y.call(e, a) && t.indexOf(a) < 0 && (s[a] = e[a]);
  if (e != null && o)
    for (var a of o(e))
      t.indexOf(a) < 0 && m.call(e, a) && (s[a] = e[a]);
  return s;
};
import { jsxs as b, Fragment as A, jsx as d } from "react/jsx-runtime";
import { u as B, b as D, l as E, m as L, I as M, B as O, n as W } from "./factory-ueRxoNOV.js";
import "react";
import { u as X } from "./use-styles-DToiHEa6.js";
import { p as Y } from "./polymorphic-factory-DufevJAl.js";
const $ = {
  gap: { type: "spacing", property: "gap" },
  rowGap: { type: "spacing", property: "rowGap" },
  columnGap: { type: "spacing", property: "columnGap" },
  align: { type: "identity", property: "alignItems" },
  justify: { type: "identity", property: "justifyContent" },
  wrap: { type: "identity", property: "flexWrap" },
  direction: { type: "identity", property: "flexDirection" }
};
var u = { root: "m_8bffd616" };
const k = {}, f = Y((e, t) => {
  const s = B("Flex", k, e), l = s, {
    classNames: a,
    className: g,
    style: x,
    styles: S,
    unstyled: F,
    vars: P,
    gap: h,
    rowGap: G,
    columnGap: N,
    align: j,
    justify: w,
    wrap: v,
    direction: _
  } = l, C = c(l, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "gap",
    "rowGap",
    "columnGap",
    "align",
    "justify",
    "wrap",
    "direction"
  ]), I = X({
    name: "Flex",
    classes: u,
    props: s,
    className: g,
    style: x,
    classNames: a,
    styles: S,
    unstyled: F,
    vars: P
  }), R = D(), n = E(), p = L({
    styleProps: { gap: h, rowGap: G, columnGap: N, align: j, justify: w, wrap: v, direction: _ },
    theme: R,
    data: $
  });
  return /* @__PURE__ */ b(A, { children: [
    p.hasResponsiveStyles && /* @__PURE__ */ d(
      M,
      {
        selector: `.${n}`,
        styles: p.styles,
        media: p.media
      }
    ),
    /* @__PURE__ */ d(
      O,
      r(r({
        ref: t
      }, I("root", {
        className: n,
        style: W(p.inlineStyles)
      })), C)
    )
  ] });
});
f.classes = u;
f.displayName = "@mantine/core/Flex";
export {
  f as F
};
